import { Injectable } from '@angular/core';
import { AuthenticatedUserObject, OkObject } from '@it2go/types';
import { MsLogonInput } from '@libs/types/src/authorization/input-type/ms-logon.input';
import { ForgottenPasswordInput } from '@libs/types/src/authorization/input-type/forgotten-password.input';
import { ResetPasswordInput } from '@libs/types/src/authorization/input-type/reset-password.input';
import { LoginInput } from '@libs/types/src/authorization/input-type/login.input';
import { StringObject } from '@libs/types/src/common/object-type/string.object';
import { LoginCodeInput } from '@libs/types/src/authorization/input-type/login-code.input';
import { LoginTokenInput } from '@libs/types/src/authorization/input-type/login-token.input';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { whoamiFrag } from '../modules/layout/services/types/init.types';

@Injectable({
    providedIn: 'root',
})
export class AuthorizationGqlService extends GqlServiceV2 {

    public msLogon(input: MsLogonInput, fragment: string = whoamiFrag) {
        return this.mutate<AuthenticatedUserObject>(
            `
                mutation($input: MsLogonInput!) {
                    authorization {
                        msLogon(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public tokenLogin(input: LoginTokenInput, fragment: string = whoamiFrag) {
        return this.mutate<AuthenticatedUserObject>(
            `
                mutation($input: LoginTokenInput!) {
                    authorization {
                        loginWithToken(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public forgottenPassword(input: ForgottenPasswordInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: ForgottenPasswordInput!) {
                    authorization {
                        forgottenPassword(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public resetPassword(input: ResetPasswordInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: ResetPasswordInput!) {
                    authorization {
                        resetPassword(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public login(input: LoginInput, fragment: string = whoamiFrag) {
        return this.mutate<AuthenticatedUserObject>(
            `
                mutation($input: LoginInput!) {
                    authorization {
                        login(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public loginCode(input: LoginCodeInput, fragment: string = whoamiFrag) {
        return this.mutate<AuthenticatedUserObject>(
            `
                mutation($input: LoginCodeInput!) {
                    authorization {
                        loginCode(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public logout(_input: null = null, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation {
                    authorization {
                        logout {
                            ${fragment}
                        }
                    }
                }
            `,
        );
    }

    public generateQrCode(_input: null = null, fragment: string = 'value') {
        return this.query<StringObject>(
            `
                query {
                    authorization {
                        generateQrCode {
                            ${fragment}
                        }
                    }
                }
            `,
        );
    }

    public disable2fa(_input: null = null, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation {
                    authorization {
                        disable2fa {
                            ${fragment}
                        }
                    }
                }
            `,
        );
    }

}
